import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockOpen16Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLockOpen16Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.255 3.071c.173-.243.468-.396.805-.483.33-.085.632-.09.73-.088h.02l.076.001c1.167 0 2.114.947 2.114 2.115V5.8H4a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.8a2 2 0 0 0-2-2h-1V4.616A3.114 3.114 0 0 0 7.839 1.5h-.034a4 4 0 0 0-.995.119c-.444.114-1.003.354-1.37.873a6 6 0 0 0-.328.496 1.3 1.3 0 0 0-.09.195l-.015.063-.002.013v.007l-.001.004v.002l.496.06-.497-.059a.5.5 0 0 0 .967.23l.011-.02c.033-.058.11-.18.274-.413M9 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockOpen16Filled);
